import React, { useEffect, useState, useRef } from 'react';
import logo75 from '../assets/images/75Years.png';
import logo from '../assets/images/logo.png';
import { useLocation } from "react-router-dom";

import '../assets/style/smart-report.css';
import PatientInfo from '../components/patientInfo';
import Benefits from '../components/benefits';
import TableOfContent from '../components/tableOfContent';
import SneakPeak from '../components/sneakpeak';
import ReportSummary from '../components/reportsummary';
import Disclaimer from '../components/disclaimer';
import References from '../components/references';
import { ImmediateTests } from '../components/recommendedTest';
import {DietRecommendarions, LifeStyleRecommendations} from '../components/recommendedDietLifestyle';
import CriticalParemeters from '../components/criticalParameters';
import ReportDetailsList from '../components/reportDetailsList';
import TrustInfo from '../components/trust';
import { QRCodeCanvas } from 'qrcode.react';
import fetchSmartReportData from '../services/apiServices';
import html2canvas from 'html2canvas';
import Preloader from '../components/preloading';

function encodeBase64(data) {
    return btoa(data); // Encoding lab number and last name in base64 format
}
function decodeBase64(encodedData) {
    return decodeURIComponent(escape(atob(encodedData))); // Decode and handle special characters
}

function PdfGeneratorLocalTest() {
    const contentRef = useRef();
    const [data, setReportData] = useState(null);
    const { search } = useLocation();
    const queryParams = new URLSearchParams(search);
    const lno = queryParams.get('lno');
    const lastName = queryParams.get('lastName');
    const hasPrinted = useRef(false); // prevents repeated calls
    // Fetch data on mount or when 'lno' changes
    useEffect(() => {
        const fetchData = async () => {
            try {
                const fetchedData = await fetchSmartReportData(lno, encodeBase64(lastName));
               // const fetchedData = await fetchSmartReportData(lno);
                if (!fetchedData || !fetchedData.data) {
                    if (fetchedData && fetchedData.message === "No record found!") {
                        setReportData({ message: "No record found!" });
                    } else {
                        setReportData(null);
                    }
                } else {
                    setReportData(fetchedData);
                }
            } catch (error) {
             //   console.log('Error fetching data:', error);
                setReportData(null);
            }
        };

        if (lno) {
            fetchData(); // Directly call the function without assignment
        }
    }, [lno]);

    const captureScreenshot = (section) => {
        return new Promise((resolve, reject) => {
            const originalWidth = section.style.width;
            const originalHeight = section.style.height;
            // Set the width and height to 595px and 842px
            // section.style.width = '980px';
            // section.style.height = '1390px';
            section.style.width = '1100px';
            section.style.height = '1560px';
            // Capture the screenshot after modifying the width of the containers
            html2canvas(section).then((canvas) => {
                const imgData = canvas.toDataURL('image/png');  // Capture the section as base64 image
                if (imgData) {
                    resolve(imgData);  // Return base64 image data
                } else {
                    reject('Failed to capture image data');
                }
                // Restore the original width and height of the section and containers after capturing the screenshot
                section.style.width = originalWidth;
                section.style.height = originalHeight;

            }).catch((error) => {
                // Restore the original width and height in case of error
                section.style.width = originalWidth;
                section.style.height = originalHeight;
                reject(error);
            });
        });
    };

    const handlePrint = async () => {
        const screenshots = [];
        const sections = contentRef.current.querySelectorAll('.section');  // Get all section elements

        // Check if there are sections
        if (sections.length === 0) {
            console.error('No sections found for screenshot capture.');
            return;
        }

        // Capture screenshot for each section
        for (let section of sections) {
            try {
                const imgData = await captureScreenshot(section);  // Capture screenshot for section
                if (imgData) {
                    screenshots.push(imgData); // Only push if screenshot data is available
                } else {
                    console.warn('No image data captured for this section.');
                }
            } catch (error) {
                console.error('Error capturing screenshot:', error);
            }
        }

        // Check if we have valid screenshots
        if (screenshots.length === 0) {
            console.error('No screenshots captured.');
            return;
        }

        // Log the screenshots data before sending
        // console.log('Sending to server:', {
        //     apiLabNumber,
        //     screenshots
        // });

        // Send the screenshots to the server to generate the PDF
        try {
            const response = await fetch('http://localhost:5000/generate-pdf', {
          // const response = await fetch('http://10.14.2.13:8080/api/pdf/generate-pdf', {
                method: 'POST',
                //mode: 'no-cors',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/json',
                   // 'Content-Type': 'application/jpeg',
                   'X-Frame-Options':'DENY'
                },
                body: JSON.stringify({
                    labNumber: apiLabNumber,
                    screenshots: screenshots,  // Send screenshots as base64 image data
                }),
                
            });

            if (!response.ok) {
                console.error('Error generating PDF:', response.statusText);
            } else {
                const pdfBlob = await response.blob();
                // Create a temporary download link
                const pdfUrl = URL.createObjectURL(pdfBlob);
                const link = document.createElement('a');
                link.href = pdfUrl;
                link.download = `smart-report-${apiLabNumber}.pdf`; // file name 
                link.click();  // Trigger the download
                URL.revokeObjectURL(pdfUrl);

            }
        } catch (error) {
            console.error('Error sending request to server:', error);
        }
    };

     useEffect(() => {
        if (
            (data?.data?.patientDetails?.PackageCode === "WM128" ||
                data?.data?.patientDetails?.PackageCode === "WR653") &&
                Array.isArray(data?.data?.smartReportListDetails) &&
                data.data.smartReportListDetails.length >= 1 &&
                !hasPrinted.current){
                     handlePrint();
                    hasPrinted.current = true;
        }
        else if (data && Array.isArray(data?.data?.smartReportListDetails) && data.data.smartReportListDetails.length > 10 && !hasPrinted.current) {
            handlePrint();
            hasPrinted.current = true;
        }  // list details is 10 by jitendra
    }, [data]); // This effect runs when 'data' changes and is not null

    // Show Preloader while fetching data
    if (!data) {
        return <Preloader />;  // Show Preloader while data is being fetched
    }

    // Show a message if no record was found
    if (data.message === "No record found!") {
        return <PatientInfo data={data} />;
    }

    // Get lab number and QR URL
    const apiLabNumber = data?.data?.patientDetails.LabNumber;
   // const qrurl = `http://localhost:3001/verify-lastname/?lno=${lno}`;
    const qrurl = `https://smartreport.lalpathlabs.com/verify-lastname/?lno=${lno}`
    
    // for getting country code
    const patientInfo = data?.data?.patientDetails || {};
    const getCountry = () => {
        const Company = (patientInfo.Company || '').toUpperCase();
        if (Company === 'BANG') {
            return 'BANGLADESH';
        } else if (Company === 'NEP') {
            return 'NEPAL';
        } else {
            return 'BHARAT';
        }
    };
    const country = getCountry();

    return (
        <>
            <div className='container-top' ref={contentRef}>

                {/* page 1 */}
                <PatientInfo data={data} />
                {/* Page 2 */}
                <Benefits />
                {/* page3 */}
                {/* <!--table of content--> */}
                <section className="section section-2" id="tableContent">
                    <div className="container">
                        <div className="row">
                            <div className="col d-flex align-items-center pt-2 pb-2 header">
                                <div>
                                    <img className="img-fluid logo-75" src={logo75} />
                                </div>
                                <div className="ms-auto">
                                    <img className="img-fluid logo-lal" alt="Dr. Lal Pathlabs" src={logo} />
                                </div>
                            </div>
                        </div>
                        <div className="row ">
                            <TableOfContent />

                        </div>
                    </div>
                </section>
                {/* <!-- end table of content--> */}

                {/* page 4 */}
                <section className="section section-3" id="report-overview">
                    <div className="container">
                        <div className="row">
                            <div className="col d-flex align-items-center pt-2 pb-2 header">
                                <div>
                                    <img className="img-fluid logo-75" src={logo75} />
                                </div>
                                <div className="ms-auto">
                                    <img className="img-fluid logo-lal" alt="Dr. Lal Pathlabs" src={logo} />
                                </div>
                            </div>
                        </div>
                        <div className="row ">
                            <SneakPeak  data={data}/>
                        </div>
                        <div className="row">
                            <div className="container-1">
                                <div className="col-12">
                                    <ul className="indicator">
                                        <li className="normal">Within Normal Limit</li>
                                        {/* <li className="borderline">Borderline</li> */}
                                        <li className="abnormal">Need attention</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="container-1">
                                <div className="col-12 mt-0">
                                    <a href="#">Click here</a> to read more about your vital parameters through our blogs.
                                </div>
                                <div className="col-12 mt-3">
                                    {apiLabNumber && (
                                        <QRCodeCanvas value={qrurl} size={150} />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* page 5 */}
                {/* <!--Summary page--> */}

                <ReportSummary data={data} />

                {/* <!--end  Summary page--> */}

                {/* crital parameters */}

                <CriticalParemeters data={data} />

                {/* page 8 */}

                <ReportDetailsList data={data} />

                {/* page 12 */}
                <section className="section section-5" id="diet-recomendation">
                    <div className="container">
                        <div className="row">
                            <div className="col d-flex align-items-center pt-2 pb-2 header">
                                <div>
                                    <img className="img-fluid logo-75" src={logo75} />
                                </div>
                                <div className="ms-auto">
                                    <img className="img-fluid logo-lal" alt="Dr. Lal Pathlabs" src={logo} />
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="container-1 benefits">
                                {/* <!--Diet recommendation--> */}
                                <DietRecommendarions  data={data}/>
                                 {/* <!--lifestyle recommendation--> */}
                                <LifeStyleRecommendations  data={data}/>
                            </div>
                        </div>
                    </div>
                </section>


                {/* page 13 */}
                <section className="section section-6 " id="test-recomendation">
                    <div className="container">


                        <div className="row">
                            <div className="col d-flex align-items-center pt-2 pb-2 header">
                                <div>
                                    <img className="img-fluid logo-75" src={logo75} />
                                </div>
                                <div className="ms-auto">
                                    <img className="img-fluid logo-lal" alt="Dr. Lal Pathlabs" src={logo} />
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="container-1 benefits">
                                <div className="col-12 mt-2 mb-5 text-center"><h2 className="panel-name"> Test recommendations </h2></div>

                                <div className="col-12 desc" style={{ marginBottom: 10 + 'px', fontWeight: 500 }}>
                                    Based on the tests conducted, here are some suggested follow-ups and additional tests that would be beneficial for you :
                                    {/* Given your lifestyle and health habits, here are some suggested tests and follow-ups that would be beneficial for you : */}
                                </div>
                                {/* <!--Initial test recommendation--> */}
                                <ImmediateTests data={data} />

                                {/* <FollowUpTests data={data} /> */}

                            </div>
                        </div>
                    </div>
                </section>


                {/* page 14 */}
                <section className="section section-7 " id="references">
                    <div className="container">
                        <div className="row">
                            <div className="col d-flex align-items-center pt-2 pb-2 header">
                                <div>
                                    <img className="img-fluid logo-75" src={logo75} />
                                </div>
                                <div className="ms-auto">
                                    <img className="img-fluid logo-lal" alt="Dr. Lal Pathlabs" src={logo} />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="container-1 benefits">

                                <References />
                                <Disclaimer />
                            </div>
                        </div>
                    </div>
                </section>

                {/* page15 */}
                 {country === 'BHARAT' && (
                <section className="section section-8 " style={{ backgroundColor: '#fffaf4' }}>
                    <TrustInfo data={data} />
                </section>
                 )}
                <div className='text-center generate-pdf-wrapper mt-3 mb-3 d-none'>
                    <button className='btn btn-primary'>Generate PDF</button>
                </div>
            </div>
        </>
    );

}

export default PdfGeneratorLocalTest;